import React, { useState } from 'react'
import { useChatContext } from 'stream-chat-react'

import UserList from './UserList'
import { CloseCreateChannel } from '../assets'

const ChannelNameInput = ({ channelName = '', setChannelName }) => {
    
  const handleChange = (event) => {
      event.preventDefault()

      setChannelName(event.target.value)
  } 

  return (
      <div className='channel-name-input__wrapper'>
          <p>Name</p>
          <input type="text" value={channelName} onChange={handleChange} placeholder='ime-kanala' />
          <p>Dodaj prejemnike</p>
      </div>
  )
} 

const EditChannel = ({ setIsEditing }) => {
  const { channel } = useChatContext()
  const [channelName, setChannelName] = useState(channel?.data?.name)
  const [selectedUsers, setSelectedUsers] = useState([]) // shouldn't it have the list of users?

  const updateChannel = async (event) => {
    event.preventDefault()
    const nameChanged = channelName !== (channel.data.name || channel.data.id) // has name been changed?

    if (nameChanged) {
      await channel.update({ name: channelName}, { text: `Channel name changed to ${channelName}`})
    }

    if (selectedUsers.length) { // new users were added
      channel.addMembers(selectedUsers)
    }

    setChannelName(null)
    setIsEditing(false)
    setSelectedUsers([])
  }

  return (
    // TODO: doesn't scale properly
    <div className='edit-channel__container'>
      <div className='edit-channel__header'>
        <p>Uredi kanal</p>
        <CloseCreateChannel setIsEditing={setIsEditing} />
      </div>
      <ChannelNameInput channelName={channelName} setChannelName={setChannelName} />
      <UserList setSelectedUsers={setSelectedUsers} />
      <div className="edit-channel__button-wrapper" onClick={updateChannel}>
        <p>Save changes</p>
      </div>
    </div>
  )
}

export default EditChannel